<template>

  <div>

    <div class="input-group-request">

      <div class="input-group-request-path">
        <div class="form-request-method">{{callLog.request.method}}</div>

        <div class="form-request-url">
          <div style="flex: auto;">
            <span class="mr-small" style="font-size: 10px">
              <i class="fas fa-lock-open fa-sm" v-if="!callLog.request.isSessionRequest" v-b-tooltip.hover title="None session request"></i>
              <i class="fas fa-lock fa-sm" v-if="callLog.request.isSessionRequest" v-b-tooltip.hover title="Session request"></i>
            </span>
            <span>{{callLog.request.protocol}}://<span id="call-env-code" class="form-request-env-value">{{callLog.environment.code}}</span>{{callLog.request.path}}</span>
            <span v-if="callLog.request.url.indexOf('?') !== -1">?{{ provideQueryParams() }}</span>
          </div>
          <b-button class="btn-circle btn-small" @click="copyUrlToClipboard">
            <i class="far fa-copy"></i>
          </b-button>
        </div>

        <div class="ml-medium"></div>

        <b-button icon variant="primary" style="height: 39px;" @click="openMockRuleCreator(callLog)" v-if="!callLog.handledByRule">
          <span class="text-nowrap"><i class="fas fa-code-branch mr-small"></i> New mock</span>
        </b-button>

        <b-button icon variant="primary" style="height: 39px;" @click="openMockRuleCreator(callLog)" v-if="callLog.handledByRule">
          <span class="text-nowrap"><i class="fas fa-code-branch mr-small"></i> Edit mock</span>
        </b-button>
      </div>

      <b-popover target="call-env-code" triggers="hover" placement="top">
        <template #title>Environment</template>
        HOST {{callLog.environment.host}}<br>
        PORT {{callLog.request.isSessionRequest ? callLog.environment.sessionPort : callLog.environment.port}}
      </b-popover>
    </div>

    <div class="nav-tabs-info-bar float-end">
      <span class="ml-medium mr-small form-small-label">Date:</span>
      <span class="form-small-value">{{callLog.createdAt | luxon({ output: { format: "yyyy-MM-dd" } })}}</span>

      <span class="ml-medium mr-small form-small-label">Time:</span>
      <span class="mr-large form-small-value">{{callLog.createdAt | luxon({ output: { format: "HH:mm:ss.SSS" } })}}</span>
    </div>

    <b-tabs>
      <b-tab active>
        <template #title>
          Headers<span class="ml-standard form-tab-info-label">({{Object.keys(callLog.request.headers).length}})</span>
        </template>
        <v-key-value-editor
          class="input-group-json"
          v-model="callLog.request.headers"
          key-placeholder="header key"
          value-placeholder="header value"
          :readonly="true"
        ></v-key-value-editor>
      </b-tab>
      <b-tab>
        <template #title>
          Body<span class="ml-standard
          form-tab-info-label">({{callLog.request.body.sizeDesc}})</span>
        </template>
        <v-ace-editor
          class="input-group-json"
          v-model="callLog.request.body.data"
          copy-message="Copied request body to clipboard"
          :content-type="callLog.request.body.contentType"
          :readonly="true"
        ></v-ace-editor>
      </b-tab>
    </b-tabs>

    <div class="nav-tabs-info-bar float-end">
      <span class="ml-medium mr-small form-small-label">Status:</span>
      <span class="badge badge-pill mr-standard" v-bind:class="[provideStatusBadgeClass(callLog.response.statusName)]">
        {{callLog.response.statusCode}} - {{callLog.response.statusName}}
        <span class="ml-extra-small fas fa-code-branch" v-if="callLog.handledByRule" v-b-tooltip.hover title="Mocked response"></span>
      </span>

      <span class="ml-medium mr-small form-small-label">Duration:</span>
      <span class="mr-small far fa-clock" style="font-size: 12px;" v-b-tooltip.hover title="Response with fixed delay"
            v-if="callLog.networkDelay"></span>
      <span class="mr-large form-small-value">{{callLog.durationDesc}}</span>
    </div>

    <b-tabs>
      <b-tab>
        <template #title>
          Headers<span class="ml-standard form-tab-info-label">({{Object.keys(callLog.response.headers).length}})</span>
        </template>
        <v-key-value-editor
          class="input-group-json"
          v-model="callLog.response.headers"
          key-placeholder="header key"
          value-placeholder="header value"
          :readonly="true"
        ></v-key-value-editor>
      </b-tab>

      <b-tab active>
        <template #title>
          Body<span class="ml-standard form-tab-info-label">({{callLog.response.body.sizeDesc}})</span>
        </template>
        <v-ace-editor
          class="input-group-json"
          v-model="callLog.response.body.data"
          copy-message="Copied response body to clipboard"
          :content-type="callLog.response.body.contentType"
          :readonly="true"
        ></v-ace-editor>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
  import axios from 'axios';
  import VAceEditor from "../../components/editors/ace/AceEditor";
  import VKeyValueEditor from "../../components/editors/keyvalue/KeyValueEditor";

  export default {
    components: {VAceEditor, VKeyValueEditor},
    data() {
      return {
        callLog: {
          handledByRule: null,
          createdAt: null,
          duration: 0,
          durationDesc: '0.000 s',
          environment: {
            code: ''
          },
          request: {
            method: null,
            protocol: null,
            path: null,
            url: null,
            headers: {},
            body: {
              contentType: 'JSON',
              data: null,
              sizeInBytes: 0,
              sizeDesc: ''
            },
            isSessionRequest: false
          },
          response: {
            headers: {},
            body: {
              contentType: 'JSON',
              data: null,
              sizeInBytes: 0,
              sizeDesc: ''
            },
            statusName: null,
            statusCode: 0
          }
        }
      };
    },
    created() {
      this.fetchLogById(this.$route.params.id);
    },
    methods: {
      fetchLogById(logId) {
        axios.get(`/api/mockConfig/callLog/${logId}`)
          .then(response => {
            this.callLog = response.data
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      provideQueryParams() {
        let query = this.callLog.request.url.substring(this.callLog.request.url.indexOf('?') + 1)
        if (query.length > 80) {
          return query.slice(0, 80) + "…"
        } else {
          return query
        }
      },
      provideStatusBadgeClass(responseStatusName) {
        if (!responseStatusName) {
          return 'badge-info'
        } else if (responseStatusName === 'OK') {
          return 'badge-success'
        } else if (responseStatusName === 'ERROR' || responseStatusName === 'FIELD_ERRORS' || responseStatusName.includes('?')) {
          return 'badge-warning'
        } else if (responseStatusName === 'TIMEOUT' || responseStatusName === 'BLOCKED' || responseStatusName === 'SERVER_ERROR') {
          return 'badge-danger'
        } else {
          return 'badge-info'
        }
      },
      copyUrlToClipboard() {
        const copiedSuccess = this.$clipboard(this.callLog.request.url);
        if (copiedSuccess) {
          this.$notify({type: 'success', message: 'Copied request URL to clipboard'})
        } else {
          this.$notify({type: 'danger', message: 'Can`t copy request URL to clipboard'})
        }
      },
      openMockRuleCreator(callLog) {
        if (callLog.handledByRule) {
          this.$router.push({name: 'mockRuleEditor', params: {id: callLog.handledByRule.id}})
        } else {
          this.$router.push({name: 'mockRuleCreator', query: {templateCallLogId: callLog.id}})
        }
      }
    },
    watch: {
      '$route.params.id': function (id) {
        this.fetchLogById(id);
      }
    }
  };
</script>
<style>

</style>
